import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";
import ContentSection from "./contentSection";

function MeetTheTeam() {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const navigate = useNavigate();

    const [mobileSubNavBarShow, setMobileSubNavBarShow] = useState(false);
    const [seeMoreButton, setSeeMoreButton] = useState(false);

    const [subNavBarSelection, setSubNavBarSelection] = useState(0);

    const [pageID, setPageID] = useState(0);

    useEffect(() => {
        const pageUUID = pagesUUIDs.find((page) => page.section == 0).uuid;
        setPageID(pageUUID);
    }, []);

    const pagesUUIDs = [
        { section: 0, uuid: 1 },
        { section: 1, uuid: 2 },
        { section: 2, uuid: 3 }
    ];

    function navBarSectionChange(section) {
        setSubNavBarSelection(section);
        const pageUUID = pagesUUIDs.find((page) => page.section == section).uuid;
        setPageID(pageUUID);
    }

    function toggleMobileMenu() {
        if (!mobileSubNavBarShow) {
            setMobileSubNavBarShow(true);
        } else {
            setMobileSubNavBarShow(false);
        }
    }

    function mobileSectionClick(section) {
        setMobileSubNavBarShow(false);
        setSubNavBarSelection(section);
    }

    const browserSubNavBar = (
        <Row>
            <Col
                style={subNavBarSelection == 0 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 0)}
            >
                Leadership
            </Col>
            <Col
                style={subNavBarSelection == 1 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 1)}
            >
                What we believe
            </Col>
            <Col
                style={subNavBarSelection == 2 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 2)}
            >
                Where are we
            </Col>
        </Row>
    );

    const mobileSubNavBar = (
        <div>
            <div style={SectionsStyles.topNavBar}>
                <div style={SectionsStyles.topBar}>
                    <div style={SectionsStyles.topBarIcon} onClick={toggleMobileMenu}>
                        <i className="fa-solid fa-bars fa-2xl"></i>
                    </div>
                    {mobileSubNavBarShow && (
                        <div style={SectionsStyles.mobileNav_navBody}>
                            <div
                                style={
                                    subNavBarSelection == 0
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 25px 0 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 25px 0 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 0)}
                            >
                                Leadership
                            </div>
                            <div
                                style={subNavBarSelection == 1 ? SectionsStyles.mobileNav_navButtonSelected : SectionsStyles.mobileNav_navButton}
                                onClick={mobileSectionClick.bind(this, 1)}
                            >
                                What we believe
                            </div>
                            <div
                                style={
                                    subNavBarSelection == 2
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 0 25px 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 0 25px 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 2)}
                            >
                                Where are we
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div
            style={{
                border: "1px solid black",
                height: "100vh",
                width: "100vw",
                backgroundImage: `url('/content/mainStyle/homeSections/backgroundImages/image2.jpeg')`,
                backgroundSize: "cover"
            }}
        >
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        {GS_generalSettings.isMobile ? mobileSubNavBar : browserSubNavBar}
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={pageID} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MeetTheTeam;
